var codeStausJson = {
  402: 'msgError402',
  4002: 'msgError4002',
  4005: 'msgError4005',
  defaultback: 'msgErrordefaultback',
  default: 'msgErrordefault',
  fromUpload: 'msgErrorfromUpload',
  fromTitle: 'msgErrorfromTitle',
  gameCodeErr: 'msgErrorGameCode',
  footballGameNoStart: 'msgFootballGameNoStart'
};
export default {
  methods: {
    // loading
    openLoading: function openLoading(alway) {
      this.$loading('');
      var self = this;
      if (!alway) {
        setTimeout(function () {
          self.closeLoading();
        }, 2000);
      }
    },
    closeLoading: function closeLoading() {
      this.$loading.close();
    },
    // 公共 弹窗
    toast: function toast(msgcode, callback) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (!msgcode) {
        return;
      }
      this.closeLoading();
      this.$toast.center(msgcode);
      if (delay) {
        setTimeout(function () {
          // eslint-disable-next-line no-unused-expressions
          callback && callback();
        }, delay);
      }
    },
    toastError: function toastError(errorCode, callback) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var msg = codeStausJson[errorCode] || 'msgErrordefault';
      this.toast(this.$t("obsPage.".concat(msg)), callback, delay);
    },
    goHome: function goHome() {
      // window.location.href = '/';
      window.location.replace('/');
    },
    errorctrlbyCode: function errorctrlbyCode(errorCode) {
      var _this = this;
      console.log(errorCode, '--errorCode--');
      var codeBackArr = ['402', '4005', 'defaultback'];
      if (codeBackArr.includes(errorCode)) {
        this.toastError(errorCode, function () {
          _this.goHome();
        }, 2000);
        return;
      }
      this.toastError(errorCode);
    }
  }
};